/**
 * @generated SignedSource<<a7d391c78e53adbbf6fa6a2c08e837b3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuMultiSelectList_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuMultiSelect_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuMultiSelectList_itemSearch";
};
export type SbSharedRefineMenuMultiSelectList_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuMultiSelectList_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelect_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "5a209a165d83096c4527b8708e849b94";

export default node;
